export const PROJECT_STATUS = {
  draft: {
    label: "Draft",
    className: "bg-ember-50 border-ember-200 text-ember-900",
  },
  active: {
    label: "Active",
    className: "bg-green-50 border-green-200 text-green-900",
  },
  inactive: {
    label: "Inactive",
    className: "bg-red-50 border-red-200 text-red-900",
  },
};
